var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisualiser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: "anticon"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 20,
    height: 20,
    viewBox: "0 0 34.3 34.4",
    style: {
      enableBackground: "new 0 0 34.3 34.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0_viz{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_cz9Je.tif_00000080911914750356636430000003586726308009830809_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0_viz",
    d: "M17.2,2.1c1.8,0,3.5,0,5.3,0c1.5,0,3,0.3,4.4,0.8c2.5,0.9,4,2.7,4.8,5.2c0.4,1.3,0.6,2.7,0.6,4.1 c0,3.4,0,6.8,0,10.2c0,1.3-0.2,2.7-0.6,4c-0.9,2.8-2.8,4.5-5.6,5.3c-1.2,0.3-2.4,0.5-3.6,0.5c-3.5,0-7,0-10.6,0 c-1.7,0-3.3-0.3-4.8-0.9c-2.3-1-3.7-2.7-4.4-5.1c-0.4-1.2-0.6-2.4-0.6-3.7c0-3.6,0-7.2,0-10.8c0-1.4,0.2-2.7,0.7-4 c0.9-2.6,2.7-4.3,5.3-5.1c1.6-0.5,3.3-0.6,4.9-0.6C14.4,2.1,15.8,2.1,17.2,2.1C17.2,2.1,17.2,2.1,17.2,2.1z M17.2,4.2 C17.2,4.2,17.2,4.2,17.2,4.2c-1.4,0-2.8,0-4.2,0c-1.3,0-2.7,0.1-4,0.4C6.7,5.2,5.3,6.5,4.6,8.8c-0.3,1-0.5,2.1-0.5,3.2 c0,3.4,0,6.7,0,10.1c0,1.1,0.1,2.2,0.4,3.3c0.5,2.1,1.8,3.6,3.9,4.2c1.1,0.4,2.3,0.5,3.5,0.6c3.2,0,6.5,0,9.7,0 c1.3,0,2.7-0.1,3.9-0.5c2.1-0.6,3.4-1.9,4.1-4c0.3-1.1,0.5-2.2,0.5-3.3c0-3.3,0-6.7,0-10c0-1-0.1-2.1-0.3-3.1 c-0.5-2.5-2-4.1-4.5-4.7c-0.9-0.2-1.9-0.4-2.9-0.4C20.6,4.2,18.9,4.2,17.2,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_viz",
    d: "M22,9.6c-0.6,0-1.2,0-1.7,0c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.4-1,1-1c1.4,0,2.8,0,4.2,0c0.5,0,1,0.4,1,0.9 c0,1.4,0,2.9,0,4.3c0,0.5-0.5,0.9-1,0.9c-0.6,0-1-0.4-1.1-1c0-0.4,0-0.8,0-1.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-3.6,3.5-7.8,5.9-12.6,7.1c-0.7,0.2-1.3-0.1-1.4-0.7c-0.2-0.6,0.2-1.1,0.9-1.3c4.6-1.2,8.6-3.5,11.9-6.9 C21.8,9.8,21.8,9.7,22,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_viz",
    d: "M25.4,21.5c0,1.4,0,2.9,0,4.3c0,0.5-0.3,0.9-0.8,1c-0.4,0.1-0.9-0.1-1.2-0.5c-0.1-0.2-0.2-0.4-0.2-0.6 c0-2.9,0-5.7,0-8.6c0-0.7,0.5-1.1,1.1-1.1c0.6,0,1,0.5,1,1.1C25.4,18.6,25.4,20,25.4,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_viz",
    d: "M18.2,22.9c0,0.9,0,1.9,0,2.8c0,0.7-0.4,1.2-1.1,1.2c-0.6,0-1-0.5-1-1.2c0-1.9,0-3.8,0-5.6 c0-0.7,0.4-1.1,1-1.1c0.6,0,1.1,0.5,1.1,1.1C18.2,21,18.2,22,18.2,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0_viz",
    d: "M8.9,24.3c0-0.5,0-0.9,0-1.4c0-0.6,0.4-1,1-1.1c0.6,0,1.1,0.4,1.1,1c0,1,0,2.1,0,3.1c0,0.6-0.5,1-1.1,1 c-0.6,0-1-0.5-1-1.1C8.9,25.3,8.9,24.8,8.9,24.3z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualiser);
export default __webpack_public_path__ + "static/media/Visualiser.f086a098.svg";
export { ForwardRef as ReactComponent };